// extracted by mini-css-extract-plugin
export default {"container":"_1QOQV","fullDivider":"_2Xkbt","divider":"_39Pzn"};